import {
  BanknoteArrowDownIcon,
  FilePenLine,
  FilePlus2,
  HandCoinsIcon,
  HandshakeIcon,
  ListTodoIcon,
  ScrollTextIcon,
} from 'lucide-react';

import type { RouteListItem } from '@/types';

import ApiIntegration from '../images/icons/api-integration.svg?react';

export const agreementsSubNav: RouteListItem[] = [
  {
    path: '/agreements/$id',
    icon: FilePlus2,
    name: 'Agreement',
    auditKey: 'agreement/profile',
  },
  {
    path: '/agreements/$id/deliverables',
    icon: ListTodoIcon,
    name: 'Deliverables',
    auditKey: 'agreement/deliverables',
  },
  {
    path: '/agreements/$id/addendum',
    icon: FilePenLine,
    name: 'Addendums',
    auditKey: 'agreement/addendum',
  },
  {
    path: '/agreements/$id/subsidies',
    icon: HandCoinsIcon,
    name: 'Subsidies',
    auditKey: 'agreement/subsidies',
  },
  {
    path: '/agreements/$id/api-integration',
    icon: ApiIntegration,
    name: 'API Integrations',
    auditKey: 'agreement/api-integration',
  },
  {
    path: '/agreements/$id/execution',
    icon: HandshakeIcon,
    name: 'Execution',
    auditKey: 'agreement/execution',
  },
  {
    path: '/agreements/$id/paperwork',
    icon: ScrollTextIcon,
    name: 'Paperwork',
    auditKey: 'agreement/paperwork',
  },
  {
    path: '/agreements/$id/commission',
    icon: BanknoteArrowDownIcon,
    name: 'Commissions',
    auditKey: 'agreement/commission',
  },
];
